import { render, staticRenderFns } from "./StudentVsQuestions.vue?vue&type=template&id=df79564a"
import script from "./StudentVsQuestions.vue?vue&type=script&lang=js"
export * from "./StudentVsQuestions.vue?vue&type=script&lang=js"
import style0 from "./StudentVsQuestions.vue?vue&type=style&index=0&id=df79564a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports